export default "__VITE_ASSET__nY1Vza6W__"